export const getOrientation = () => {
  // For SSR
  if (typeof window === 'undefined') {
    return 'landscape';
  }

  // For client-side render
  if (screen.orientation || screen.mozOrientation) {
    return (screen.orientation || screen.mozOrientation).type.indexOf('portrait') > -1 ? 'portrait' : 'landscape';
  } else if (screen.msOrientation) {
    return screen.msOrientation.indexOf('portrait') > -1 ? 'portrait' : 'landscape';
  } else if (typeof window.orientation !== 'undefined') {
    return (Math.abs(window.orientation) === 90 ? 'landscape' : 'portrait');
  }

  return 'landscape';
};



// WEBPACK FOOTER //
// ./helpers/orientation.helper.js